export var CampaignAction;
(function (CampaignAction) {
    CampaignAction["CreateTeam"] = "CreateTeam";
    CampaignAction["IndividualFundraising"] = "IndividualFundraising";
    CampaignAction["JoinTeam"] = "JoinTeam";
})(CampaignAction || (CampaignAction = {}));
